import { Question } from './question';

export class QuestionRating extends Question{

  stepNum:number = 10;
  lowerText:string = "低い";
  higherText:string = "高い";
  steps:Array<number> = [];
  
  constructor(object = null){
    super();
    this.type = 'QuestionRating';
    this.typeText = "評価";

    if(object){
      super.set(object);
      this.set(object);
    }

    for(let index:number = 1; index < this.stepNum + 1; index++){
      this.steps.push(index);
    }
  };

  set(object){
    if(object.stepNum){
      this.stepNum = object.stepNum;
    }
    if(object.lowerText){
      this.lowerText = object.lowerText;
    }
    if(object.higherText){
      this.higherText = object.higherText;
    }
  }
}
